import { jsx as m } from "react/jsx-runtime";
import { c as l } from "./index-65016bfa.mjs";
import u, { css as n } from "styled-components";
import "@fcamna/shared-component-foundations";
import "react";
import { u as p } from "./useQuantum-50e8fd44.mjs";
import "./isClient-ec947a14.mjs";
import "./useSlots-a1aa6a84.mjs";
import "./_commonjsHelpers-92157f1b.mjs";
const a = "DISCLOSURE_CONTENT_TEST_ID", D = u.div`
  &.Disclosures {
    ${({
  theme: {
    components: { disclosure: s }
  }
}) => n(s.Disclosure)};
  }
`, I = ({ id: s, disclosureContent: o, disclosureTitleColor: t, className: r, style: e }) => {
  const c = p({ label: "Disclosure" }), i = {
    color: t
  };
  return /* @__PURE__ */ m(
    D,
    {
      id: s,
      "data-testid": `${a}_disclosure_content`,
      className: l(["Disclosures", r]),
      style: { ...i, ...e },
      ...c,
      children: o
    }
  );
};
export {
  I as Disclosures
};
